.dialogTitle {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* HelpIcon nudges itself down for inline text flow; undo that so it centers in the flex row */
.dialogTitle svg {
    top: 0;
    padding-bottom: 0;
}

.propertyLabelRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
}

.labelActions {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

.existingLabelsHeading {
    margin-top: 24px;
    margin-bottom: 12px;
}

.addLabelButton {
    margin-top: 20px;
}

.colorPicker {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.colorPickerLabel {
    font-size: 1rem;
}

.colorRow {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.colorSwatch {
    width: 18px;
    height: 18px;
    padding: 0;
    border: none;
    border-radius: 50%;
    cursor: pointer;
}

.colorSwatchSelected {
    box-shadow: 0 0 0 1px white, 0 0 0 3px rgb(97, 97, 97);
}

.editForm,
.confirmDeleteForm {
    width: 100%;
}

.modalButtonRow {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    padding-top: 28px;
}
